import React, { useState, useContext } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { useRequest } from 'ahooks';
import { Modal } from 'antd';
import { TableLv2 } from '@/components';
import { StoreContext } from '@/stores';
import { fetchNoticeList, saveNotice, deleteNotice } from './api';
import FormModal from './form-modal';

import './index.less';

const HomeNoticeBoard: React.FC = () => {
    const store = useContext(StoreContext);

    const { data, loading, refresh } = useRequest(fetchNoticeList);
    console.log('/crm/notice/select', data);

    const userStore = store.getAuthStore();
    const { defaultMenuPermStore } = userStore;

    const { visible } = defaultMenuPermStore.getPermByKey('om-file-notice');

    const [visibleModal, setVisibleModal] = useState(false);
    const [initialValues, setInitialValues] = useState<any>(null);

    return (
        <>
            <FormModal
                visible={visibleModal}
                initialValues={initialValues}
                onClose={() => setVisibleModal(false)}
                onSubmit={async val => {
                    setVisibleModal(false);
                    console.log('val', val);
                    const success = await saveNotice(val);
                    if (success) {
                        refresh();
                    }
                }}
            />
            <div className="home-new-right-info-content">
                <div className="crm-home-customer-info">
                    <p className="home-page-title">
                        通知栏
                        {visible && (
                            <span
                                className="home-page-customer-create"
                                onClick={() => setVisibleModal(true)}
                            >
                                新建
                            </span>
                        )}
                    </p>
                    <div className="home-customer-info-body">
                        <TableLv2<any>
                            dataSource={data}
                            loading={loading}
                            columns={[
                                {
                                    title: '主题',
                                    dataIndex: 'title',
                                    width: 160,
                                    render: (v, record) => {
                                        return (
                                            <a
                                                href={record.url}
                                                target="_blank"
                                            >
                                                {v}
                                            </a>
                                        );
                                    },
                                },
                                {
                                    title: '说明',
                                    dataIndex: 'notes',
                                    width: 160,
                                    render: v => v || '--',
                                },
                                {
                                    title: '发布人',
                                    dataIndex: 'ownerName',
                                    width: 60,
                                    render: v => (_.isNil(v) ? '--' : v),
                                },
                                {
                                    title: '更新时间',
                                    dataIndex: 'updateTime',
                                    ellipsis: true,
                                    width: 60,
                                    render: v => {
                                        return moment(v).format('MM-DD');
                                    },
                                },
                            ]}
                            actions={
                                visible
                                    ? [
                                          {
                                              actionKey: 'update',
                                              actionCn: '修改',
                                          },
                                          {
                                              actionKey: 'delete',
                                              actionCn: '删除',
                                          },
                                      ]
                                    : []
                            }
                            onAction={(actionKey, record) => {
                                if (actionKey === 'update') {
                                    setVisibleModal(true);
                                    setInitialValues(record);
                                }
                                if (actionKey === 'delete') {
                                    Modal.confirm({
                                        title: '删除通知',
                                        content: (
                                            <p>删除成功之后，该操作无法恢复</p>
                                        ),
                                        icon: null,
                                        onOk: async () => {
                                            await deleteNotice(record.id);
                                            refresh();
                                        },
                                    });
                                }
                            }}
                            actionsWidth={90}
                            closeRowSelection={true}
                            rowKey={record => record.id}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
export default HomeNoticeBoard;
